<template>
  <table class="ui-table mb-16">

    <tr>

      <th>
        <div class="star-pad">
          <UiStar></UiStar>
        </div>
      </th>

      <th>
        <div>{{$t('ActiveInvoices.applicant')}}</div>
      </th>
      <th>
        <div>{{$t('ActiveInvoices.status')}}</div>
      </th>
      <th>
        <div>{{$t('ActiveInvoices.due_date')}}</div>
      </th>
      <th>
        <div>{{$t('ActiveInvoices.required_amount')}}</div>
      </th>
      <th>
        <div>{{$t('ActiveInvoices.level')}}</div>
      </th>
      <th>
        <div>{{$t('ActiveInvoices.paid_amount')}}</div>
      </th>
    </tr>

    <tr
        v-for="item in items"
        :key="item.id"
        @click="$emit('select', item)"
        class="hoverable" :class="{hover: item.id === currentItemId}">

      <td>
        <div class="table-cell star-pad">
          <UiStar :user="item"></UiStar>
        </div>
      </td>

      <td>
        <div class="table-cell nowrap">
          <UiAvatar class="user-avatar" :src="getAvatarUrl(item?.user?.photo?.key)"></UiAvatar>
          <span>
            {{ item.firstName }}&nbsp;{{ item.middleName }}&nbsp;{{ item.lastName }}
            <div class="mini-date">{{ $dayjs(item.createdAt).format('DD/MM/YYYY') }}</div>
          </span>
        </div>
      </td>
      <td>
        <UiStatus :student="item"></UiStatus>
      </td>
      <td>
        <div>{{ $dayjs(item.root.levelPayment.dueDate).add(5, 'day').format('DD/MM/YYYY') }}</div>
      </td>
      <td>
        <div>{{ item.root.levelPayment.requiredAmount }}€</div>
      </td>
      <td>
        <div class="uppercase">{{ item.root.levelPayment.languageLevel }}</div>
      </td>
      <td>
        <div>{{item.root.paidAmount}} {{item.root.currency}}</div>
      </td>
    </tr>
  </table>
</template>

<script>
import config from "@/config";
import UiAvatar from "@/components/ui/UiAvatar";
import UiStar from "@/components/ui/UiStar";
import UiStatus from "@/components/ui/UiStatus";

export default {
  name: "ActiveInvoices",
  components: {UiStatus, UiStar, UiAvatar},
  props: {
    items: {
      type: Array,
      required: true,
    },
    currentItemId: {}
  },
  emits: ['select'],
  methods: {
    getAvatarUrl(key) {
      if (key) return `${config.backendUrl}/${key}?token=${localStorage['feathers-jwt']}`;
      else return require('@/assets/images/no-avatar.jpg')
    },
    downloadCV(student) {
      const url = `${config.backendUrl}/${student.cv.key}?token=${localStorage['feathers-jwt']}`
      this.$log(url);
      window.open(url);
    },
  }
}
</script>

<style scoped>

</style>